import React, { useEffect, useState } from "react";
import { dateTimeToView } from "helpers/date";
import { addFile, deleteFile, getFiles } from "sources/books/distributionBids";

export default function DistributionBidFiles(props) {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const loadData = () => {
        setLoading(true);
        getFiles(props.id).then((res) => {
            setData(res);
            setLoading(false);
        });
    };
    useEffect(() => {
        loadData();
    }, []);
    const addNewFile = () => {
        return props.add({
            name: "fileUpload",
            title: "Загрузка файла",
            propName: "file",
            uploadFile: (params) => {
                params.body.append("distributionBidId", props.id);

                return addFile(params);
            },
            action: () => {
                loadData();
            },
        });
    };
    const removeFile = (id) => {
        return props.add({
            name: "confirm",
            title: "Удалить файл?",
            action: () => deleteFile({ distributionBidId: props.id, fileId: id }).then(loadData),
            buttons: { confirm: "Да", cancel: "Нет" },
        });
    };

    const renderFiles = () => {
        if (data.length === 0) {
            return <p className="text-center">Файлы еще не загружены</p>;
        }
        return (
            <table className="table table-sm">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Название</th>
                        <th>Дата загрузки</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, i) => (
                        <tr key={item.id}>
                            <td>{i + 1}</td>
                            <td>
                                <a target="_blank" rel="noopener noreferrer" href={item.accessUrlLink}>
                                    {item.originalFileName}
                                </a>
                            </td>
                            <td className="text-nowrap">{dateTimeToView(item.createdAt)}</td>
                            <td>
                                {props.canManageFiles && (
                                    <div className="btn btn-xs btn-danger" onClick={() => removeFile(item.id)}>
                                        <i className="icon-uEA31-trash" />
                                    </div>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };
    return (
        <div className={loading ? "loading" : ""}>
            {renderFiles()}
            {props.canManageFiles && (
                <div className="inline-btn inline-btn--plus" onClick={addNewFile}>
                    Добавить файл
                </div>
            )}
        </div>
    );
}
